import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=6d9224a9&scoped=true&"
import script from "./QuickAccess.vue?vue&type=script&lang=js&"
export * from "./QuickAccess.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccess.vue?vue&type=style&index=0&id=6d9224a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9224a9",
  null
  
)

export default component.exports